<script>
import mapValues from 'lodash/mapValues'
import every from 'lodash/every'
import values from 'lodash/values'
import {
  deviceListComputed,
  deviceListMethods,
} from '@state/helpers/device-list'

import { nameListComputed, nameListMethods } from '@state/helpers/name-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, addParamsToLocation } from '@utils/helpers'
import cloneDeep from 'lodash/cloneDeep'
import { ROLE } from '@utils/constant'
import { requestUpload } from '@/src/services'
import store from '@state/store'
import tableFields from './tableFields'

export default {
  page: {
    title: 'Device List Agent Admin',
    meta: [
      { name: 'description', content: 'The Device List Agent Admin page.' },
    ],
  },
  data() {
    return {
      items: {},
      currentUser: store.getters['auth/getCurrentUser'],
      searchBody: new SearchPayload.Builder().withAgentId().withSearchMac(),
      fields: tableFields,
      filtered: false,
      openConfirm: false,
      openConfirmRegister: false,
      openConfirmEdit: false,
      openConfirmUpload: false,
      deviceIdSelected: {},
      switchId: null,
      disabledUploadCSV: true,
      toggle: {},
      feedback: '',
      deviceEdit: {
        agent_id: null,
        device_name: '',
        company: '',
      },
      deviceRegister: {
        agent_id: null,
        mac: '',
        device_name: '',
      },
      deviceSearch: {
        search_mac: '',
        search_device_name: '',
        order_by: '',
      },
      showRegister: false,
      showSearch: false,
      registerDropdownkey: null,
      files: null,
      event: null,
      showEditModal: false,
      roleUser: null,
      ROLE: ROLE,
      classSearchDropdown:
        'btn btn-outline-dark feeline-border-left border-left-0',
    }
  },
  computed: {
    ...deviceListComputed,
    ...nameListComputed,
    getAgentId() {
      return this.currentUser?.agent.id
    },
    deviceListData() {
      const list =
        cloneDeep(this.getDeviceList?.list)?.map((item) => {
          item.agent_id = item.id
          if (item.mesure_count === 0) {
            item.mesure_count = '-'
          }
          if (item.mesure_unique_member === 0) {
            item.mesure_unique_member = '-'
          }
          if (item.last_measure_time === '-') {
            item.last_measure_time = ''
          }
          return item
        }) || []
      return list
    },
    optionsSelectCompany() {
      const options = cloneDeep(this.getNameList?.list)?.map((item) => {
        return {
          value: item.id.toString(),
          label: item.company,
        }
      })
      return options
    },
    paginationComputed() {
      let paginations = {}
      if (this.getDeviceList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getDeviceList
        )
      }
      return paginations
    },
    unselectedAll() {
      return every(values(this.deviceIdSelected), function(v) {
        return !v
      })
    },
    loadingComputed() {
      return this.loading
    },
    confirmComputed() {
      if (this.unselectedAll) {
        return 'unselected'
      }
      return 'delete'
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
    },
    files() {
      if (this.files[0].type !== 'application/vnd.ms-excel') {
        this.feedback = 'This file not format CSV'
        this.disabledUploadCSV = true
      } else {
        this.feedback = ''
        this.disabledUploadCSV = false
      }
    },
    showRegister() {
      this.registerDropdownkey = new Date().getTime()
      this.deviceRegister = mapValues(this.deviceRegister, () => '')
    },
    getRegisterErrors() {
      this.$refs.register.setErrors(this.getRegisterErrors)
    },
  },
  created() {
    const filter = this.$route.query
    if (filter.page_no) {
      filter.page_no = parseInt(filter.page_no, 10)
      filter.lines = parseInt(filter.lines, 10)
      for (const key in filter) {
        if (filter[key] === 'undefined') {
          filter[key] = ''
        }
        if (key !== 'page_no' && key !== 'lines') {
          if (filter[key] !== '' && filter[key] !== undefined) {
            this.searchBody = filter
            this.filtered = true
          }
        }
      }
      if (filter.page_no > 1) {
        this.searchBody = filter
      }
    }

    this.deviceSearch.search_mac = filter.search_mac
    this.deviceSearch.search_device_name = filter.search_device_name
    this.handleSearchDevice()
    this.fetchingNameList()
    const user = this.$store.getters['auth/getCurrentUser']
    this.roleUser = user.level
    this.$router
      .replace({
        query: { ...this.$route.query, agent_code: user?.agent?.agent_code },
      })
      .catch(() => {})
    if (this.roleUser === ROLE.AGENT_AUDIT) {
      this.fields = this.fields.slice(2)
      this.classSearchDropdown = 'btn btn-outline-dark'
    }
  },
  methods: {
    ...deviceListMethods,
    ...nameListMethods,
    showModal() {
      this.openConfirm = !this.openConfirm
    },
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchDevice()
    },
    handleSorter(key) {
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchDevice()
    },
    handleSearchDevice() {
      const agentId = this.getAgentId
      const body = { agent_id: agentId.toString() }
      this.fetchingDeviceList({ ...this.searchBody, ...body })
    },
    goToAddNewPage() {
      this.$router.push({ name: 'agentRegistration' })
    },
    handleSelected(id, value) {
      const temp = { ...this.deviceIdSelected }
      temp[id] = value
      this.deviceIdSelected = { ...temp }
    },
    searchDevice() {
      this.searchBody = { ...this.searchBody, ...this.deviceSearch }
      this.handleSearchDevice()
      this.filtered = true
      this.showSearch = false
    },
    async submitRegister() {
      const response = await this.registerDevice({
        agent_id: this.getAgentId,
        device_name: this.deviceRegister.device_name,
        mac: this.deviceRegister.mac,
        model: '',
      })
      if (response) {
        this.showRegister = false
        this.handleSearchDevice()
        this.openConfirmRegister = false
      }
    },
    clearSearch() {
      this.deviceSearch = mapValues(this.deviceSearch, () => '')
      this.searchBody = { ...this.deviceSearch }
      this.handleSearchDevice()
      this.filtered = false
      this.showSearch = false
    },
    async submitEdit() {
      const response = await this.editDeviceById({
        id: this.switchId,
        agent_id: parseInt(this.deviceEdit.agent_id),
        device_name: this.deviceEdit.device_name,
        model: '',
      })
      if (response) {
        this.showEditModal = false
        this.openConfirmEdit = false
        this.handleSearchDevice()
      }
    },
    submit() {
      const temp = { ...this.deviceIdSelected }
      const flag = []
      for (const id in temp) {
        if (temp[id]) {
          flag.push(parseInt(id))
        }
      }
      Promise.all(
        flag?.map((id) => {
          return this.deleteDeviceById({ id })
        })
      ).then(() => {
        this.openConfirm = !this.openConfirm
        this.fetchingDeviceList(this.searchBody)
        this.deviceIdSelected = {}
      })
    },
    handleEditModal(item) {
      this.showEditModal = true
      this.switchId = item.device_id
      this.deviceEdit.agent_id = item.agent_id.toString()
      this.deviceEdit.device_name = item.device_name
      this.deviceEdit.company = item.company
    },
    goDetailPage(id, columnName, event) {
      if (columnName === 'edit') {
        return
      }
      this.$router.push({
        path: `/panel/device-list-agent-admin/${id}`,
      })
    },
    async upload() {
      this.openConfirmUpload = false
      try {
        if (this.files[0]) {
          const formData = new FormData()
          formData.append('csv_file', this.files[0])
          const response = await requestUpload(
            '/cms/device/add_from_csv/',
            formData
          )
          if (response) {
            this.handleSearchDevice()
            this.disabledUploadCSV = true
            this.event.target.value = ''
          }
        }
      } catch (err) {
        this.event.target.value = ''
        this.disabledUploadCSV = true
      }
    },
    changeFiles(files, event) {
      this.files = files
      this.event = event
    },
  },
}
</script>

<template>
  <div>
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    >
      <template v-slot:secondary>
        <CButtonGroup id="feeline-group-btn">
          <CDropdown
            v-if="roleUser !== ROLE.AGENT_AUDIT"
            :show.sync="showRegister"
            placement="bottom-start"
            toggler-text="新規登録"
            add-toggler-classes="btn btn-outline-dark feeline-border-right"
            add-menu-classes="p-2"
          >
            <validation-observer ref="register" v-slot="{ handleSubmit }">
              <CForm
                :key="registerDropdownkey"
                @submit.stop.prevent="
                  handleSubmit(() => {
                    openConfirmRegister = true
                  })
                "
              >
                <BaseInput
                  v-model="deviceRegister.mac"
                  label="Macアドレス"
                  name="macAddress"
                  vee-name="macAddress"
                  :rules="{ requiredWithFormat: true, mac: true }"
                />
                <BaseInput
                  v-model="deviceRegister.device_name"
                  label="デバイス名"
                  :rules="{ required: true, max: 16 }"
                />
                <CButton
                  color="dark"
                  variant="outline"
                  class="w-100"
                  type="submit"
                >
                  登録
                </CButton>
              </CForm>
            </validation-observer>
          </CDropdown>
          <CDropdown
            v-if="roleUser !== ROLE.AGENT_AUDIT"
            placement="bottom-start"
            toggler-text="CSV一括登録"
            add-toggler-classes="btn btn-outline-dark rounded-0 border-left-0"
            add-menu-classes="p-2"
          >
            <template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <CForm
                  ref="form"
                  @submit.stop.prevent="
                    handleSubmit(() => {
                      openConfirmUpload = true
                    })
                  "
                >
                  <CInputFile
                    :invalid-feedback="feedback"
                    accept=".csv"
                    placeholder="Browse"
                    @change="(files, event) => changeFiles(files, event)"
                  >
                    <template v-slot:invalid-feedback>
                      <div class="invalid-csv">{{ feedback }}</div>
                    </template>
                  </CInputFile>
                  <CButton
                    color="primary"
                    type="submit"
                    class="w-100"
                    :disabled="disabledUploadCSV"
                  >
                    アップロード
                  </CButton>
                </CForm>
              </validation-observer>
            </template>
          </CDropdown>
          <CButton
            v-if="roleUser !== ROLE.AGENT_AUDIT"
            color="dark"
            variant="outline"
            @click="showModal"
            >削除
          </CButton>
          <CDropdown
            :show.sync="showSearch"
            placement="bottom-start"
            :add-toggler-classes.sync="classSearchDropdown"
            add-menu-classes="p-2"
          >
            <template v-slot:toggler-content>
              <font-awesome-icon icon="search" />
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <CForm
                ref="form"
                @submit.stop.prevent="handleSubmit(searchDevice)"
              >
                <BaseInput
                  v-model="deviceSearch.search_mac"
                  label="Macアドレス"
                />
                <BaseInput
                  v-model="deviceSearch.search_device_name"
                  label="デバイス名"
                />
                <div class="d-flex">
                  <CButton color="primary" type="submit" class="w-50">
                    検索
                  </CButton>
                  <CButton color="light" class="ml-2 w-50" @click="clearSearch">
                    クリア
                  </CButton>
                </div>
              </CForm>
            </validation-observer>
          </CDropdown>
        </CButtonGroup>
      </template>
    </BasePagination>
    <BaseTable
      striped
      hover
      border
      :loading="loadingComputed"
      :table-fields="fields"
      :data-tables="deviceListData"
      @sorterBy="handleSorter"
      @row-clicked="
        (item, index, columnName, event) =>
          goDetailPage(item.device_id, columnName, event)
      "
    >
      <template v-slot:checkbox="{ item }">
        <td class="py-2" @click.stop="() => {}">
          <CInputCheckbox
            :checked="deviceIdSelected[item.device_id]"
            color="primary"
            @update:checked="(v) => handleSelected(item.device_id, v)"
          />
        </td>
      </template>
      <template v-slot:edit="{ item }">
        <td>
          <CButton
            variant="outline"
            color="danger"
            @click="handleEditModal(item)"
          >
            <simple-line-icons icon="pencil" no-svg />
          </CButton>
        </td>
      </template>
    </BaseTable>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirm"
      :type="confirmComputed"
      :hide-action-button="unselectedAll"
      @closeModal="openConfirm = !openConfirm"
      @submit="submit"
    />
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmRegister"
      type="add"
      @closeModal="openConfirmRegister = !openConfirmRegister"
      @submit="submitRegister"
    />
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmUpload"
      type="add"
      @closeModal="openConfirmUpload = !openConfirmUpload"
      @submit="upload"
    />
    <BaseFormModal
      :show-modal="showEditModal"
      @close="showEditModal = false"
      @submit="openConfirmEdit = true"
    >
      <template v-slot:form>
        <BaseInput
          v-model="deviceEdit.device_name"
          :rules="{ required: true, max: 16 }"
        />
      </template>
    </BaseFormModal>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirmEdit"
      type="edit"
      @closeModal="openConfirmEdit = !openConfirmEdit"
      @submit="submitEdit"
    />
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feeline-border-right {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

::v-deep .feeline-border-left {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

::v-deep .invalid-csv {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #e55353;
}

#feeline-group-btn {
  ::v-deep .dropdown-menu {
    min-width: 12rem;
  }
}
</style>
